export default __webpack_public_path__ + "static/media/graphics.5395c0bb.svg";